module.exports = __webpack_public_path__ + "static/img/complianceSystem2.b0c9ba6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/complianceSystem2.jpg
// module id = NZLa
// module chunks = 1